import React from 'react';
import PropTypes from 'prop-types';

const ItemError = ({ message }) => (
  <div className="alert-inline alert-inline--danger">
    {// eslint-disable-next-line react/no-danger
    }<span className="alert-inline__message" dangerouslySetInnerHTML={{ __html: message }} />
  </div>
);

ItemError.propTypes = {
  message: PropTypes.string.isRequired,
};
export default ItemError;
